import EventsTracking from '../../../shared/eventsTracking';

function setup(el, binding) {
  const onToggle = (event) => {
    const details = event.currentTarget;
    if (!details.open) return;

    const group = details.dataset.faqGroup;
    if (!group) return;

    el.querySelectorAll(`details[data-faq-group="${group}"][open]`).forEach((other) => {
      if (other !== details) {
        other.open = false;
      }
    });
  };

  const detailsList = el.querySelectorAll('details');
  detailsList.forEach((details) => details.addEventListener('toggle', onToggle));

  const { taggingId } = binding.value || {};
  if (taggingId) {
    // eslint-disable-next-line sonarjs/constructor-for-side-effects
    new EventsTracking(taggingId);
  }
}

export default {
  // Vue 2
  inserted(el, binding) {
    setup(el, binding);
  },
  mounted(el, binding) {
    setup(el, binding);
  },
};
